/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-empty-route-view',
  template: ''
})
export class EmptyRouteViewComponent {
}

@Component({
  standalone: false,
  selector: 'adn-static-route-title',
  template: '<h1>{{title}}</h1>'
})
export class StaticRouteTitleComponent {
  @Input() title = '';
}

@Component({
  standalone: false,
  selector: 'adn-container-state-title',
  template: `
    <div class="container container-large singlePageEdit">
      <adn-state-title></adn-state-title>
    </div>
  `
})
export class ContainerStateTitleComponent {
}

export function emptyRouteView(): any {
  return {
    component: EmptyRouteViewComponent
  };
}

export function staticRouteTitleView(): any {
  return {
    component: StaticRouteTitleComponent,
    bindings: {
      title: 'routeTitle'
    }
  };
}

export function containerStateTitleView(): any {
  return {
    component: ContainerStateTitleComponent
  };
}
